import { ChainId } from '@nominex/nomiswap-sdk'
import chunk from 'lodash-es/chunk'
import lpToken from 'config/abi/ILpTokenContract.json'
import { SerializedFarmConfig } from 'config/farms'
import { SerializedFarm } from 'state/types'
import multicall from 'utils/multicall'

function mapCalls(farm: SerializedFarm) {
  const { lpAddress, token, quoteToken } = farm

  return [
    // Balance of token in the LP contract
    {
      address: token.address,
      name: 'balanceOf',
      params: [lpAddress],
    },
    // Balance of quote token on LP contract
    {
      address: quoteToken.address,
      name: 'balanceOf',
      params: [lpAddress],
    },
    // Total supply of LP tokens
    {
      address: lpAddress,
      name: 'totalSupply',
    },
    // Token decimals
    {
      address: token.address,
      name: 'decimals',
    },
    // Quote token decimals
    {
      address: quoteToken.address,
      name: 'decimals',
    },
  ]
}

export const fetchLpData = async (farms: SerializedFarmConfig[], chainId: ChainId): Promise<any[]> => {
  const calls = farms.flatMap(mapCalls)
  const chunkSize = calls.length / farms.length
  const multicallResult = await multicall(lpToken, calls, chainId)

  return chunk(multicallResult, chunkSize)
}
